import React, { useState } from "react";
import {
  FormGroup,
  Label,
  Input,
  SubmitButton,
  InstructionText,
} from "./Login.styles.js";

const RequestResetForm = ({ onRequestReset, loading, switchToLogin }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onRequestReset(email);
  };

  return (
    <>
      <InstructionText>
        Enter your email address and we'll send you a link to reset your
        password.
      </InstructionText>
      <FormGroup>
        <Label htmlFor="forgot-email">Email Address</Label>
        <Input
          type="email"
          id="forgot-email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="Enter your registered email"
        />
      </FormGroup>
      <SubmitButton onClick={handleSubmit} disabled={loading}>
        {loading ? "Sending..." : "Send Reset Link"}
      </SubmitButton>
    </>
  );
};

export default RequestResetForm;
